
import Ugcs from "@/components/Ugcs.vue";
import { RelUgcBestVO } from "@/views/biz/ugc/vo/ugc.vo";
import axios from "axios";
import { Swiper } from "swiper/js/swiper.esm";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: { Ugcs },
})
export default class BestReviews extends Vue {
  @Prop({ default: true })
  active?: boolean;
  @Prop()
  propBestReviews?: Array<RelUgcBestVO>;
  @Prop()
  ugcCd?: number;

  keyword = "";
  bestReviews: Array<RelUgcBestVO> = [];

  // 베스트 리뷰 swiper
  swiperBest: Swiper;
  swiperBestOptions = {
    slidesPerView: 2.8,
    freeMode: true,
    spaceBetween: this.$isMobile ? 10 : 10,
    lazy: true,
    nested: true,
  };

  // 베스트 보여줌?
  get showBests() {
    return this.$route.name === "Main" || !this.$isMobile;
  }

  @Watch("active", {immediate: true})
  @Watch("ugcCd")
  onReviewActivated() {
    if (this.propBestReviews) {
      this.bestReviews = this.propBestReviews;
    }
    !this.bestReviews.length && this.getBestReviews();
  }
  getBestReviews(): void {
    const params = {
      ugcTypeCd: "047001",
    };
    axios.get(`/ugc/best`, { params: params }).then((r) => {
      this.bestReviews = r.data as Array<RelUgcBestVO>;
      this.$emit("layout-update");
      this.swiperBest && this.swiperBest.slideTo(0);
    });
  }
}
